import { Puzzle, Stack } from "components/icons/generated";
import Box from "ds/components/Box";
import Link from "ds/components/Link";
import useTypedContext from "hooks/useTypedContext";
import { EnvironmentContext } from "components/Environment/EnvironmentContext";

import { VariableCellComponentProps } from "./types";

const SourceCell = ({ context, stackDependency }: VariableCellComponentProps) => {
  const { canCreateAndEditVariables } = useTypedContext(EnvironmentContext);
  const dependencyStack = stackDependency?.dependsOnStack;
  if (dependencyStack) {
    return (
      <Box align="center">
        <Link
          disabled={!canCreateAndEditVariables}
          href={`/stack/${dependencyStack?.id}/dependencies`}
          startIcon={Stack}
        >
          {dependencyStack.name}
        </Link>
      </Box>
    );
  }

  if (context) {
    return (
      <Box align="center">
        <Link
          disabled={!canCreateAndEditVariables}
          href={`/context/${context?.contextId}`}
          startIcon={Puzzle}
        >
          {context?.contextName}
        </Link>
      </Box>
    );
  }

  return null;
};

export default SourceCell;
